const rootPath = '/svg';

const svgFiles = {
  genericUser: `${rootPath}/generic-user.svg`,
  calendarGray: `${rootPath}/calendarGray.svg`,
  handshakeGray: `${rootPath}/handshakeGray.svg`,
  handshakePurple: `${rootPath}/handshakePurple.svg`,
  arrowRightCurvedWhite: `${rootPath}/arrow-right-curved-white.svg`,
};

export default svgFiles;
